import React from 'react';
import './footer.css';

class Footer extends React.Component {
  render() {
    return <div className='footer'>©2018 Jordan Outdoor Enterprises, Ltd. All rights reserved.</div>
  }
}

export default Footer;


// WEBPACK FOOTER //
// ./src/components/footer/footer.js